import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private apiUrl = environment.apiUrl;

    public empCareerUserDetails = new BehaviorSubject<any>(localStorage.getItem('empCareerUserDetails'));

    constructor(private http: HttpClient) { }

    public fetchUsersList(): Observable<any> {
        const url = this.apiUrl + 'User/FetchAllUsers';
        return this.http.get<any>(url);
    }

    public updateUser(user: any): Observable<any> {
        const url = this.apiUrl + 'User/UpdateUser';
        return this.http.post<any>(url, user);
    }

    public deleteUser(userId: string): Observable<any> {
        const url = this.apiUrl + 'User/DeleteUser/' + userId;
        return this.http.get<any>(url);
    }

    public addUser(user): Observable<any> {
        const url = this.apiUrl + 'User/CreateUser';
        return this.http.post<any>(url, user);
    }

    public searchGrid(searchTerm: string): Observable<any> {
        const url = this.apiUrl + 'User/GridSearch/' + searchTerm;
        return this.http.get<any>(url);
    }

    public deleteMultipleUsers(userIds: string[]): Observable<any> {
        const url = this.apiUrl + 'User/DeleteMultipleUsers/';
        return this.http.post<any>(url, userIds);
    }
}
